import { useCallback, useState } from 'react';

/** Open/close state with an optional payload, used by every dialog and sheet. */
export default function useDisclosure(initial = false) {
  const [isOpen, setIsOpen] = useState(initial);
  const [payload, setPayload] = useState(null);

  const open = useCallback((value = null) => {
    setPayload(value);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setPayload(null);
  }, []);

  const toggle = useCallback(() => setIsOpen((v) => !v), []);

  return { isOpen, payload, open, close, toggle };
}
